var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-width pl-5 pr-5"},[_c('div',{staticClass:"text-xs-center mb-5"},[_c('h1',{staticClass:"sz-kath-title"},[_vm._v(_vm._s(_vm.title.value))])]),_c('KirchenvostandComp'),_c('div',{staticClass:"pt-5 text-xs-center"},[_c('RechenschaftsberichteComp',{staticClass:"subpage-wrapper-small"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }